// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      name: '供应商',
      prop: 'payeeNo',
      type: 'searchTableSpec',
      searchType: 'sapCustomer',
      disabled: true,
      isMultiple: true,
      span: 7,
      // changeMethod: ctx.changeSupplyChainMethod,
      currentValue: ctx.query?.payeeName,
    },
    // {
    //   name: '结算单状态',
    //   prop: 'settlementStatus',
    //   type: 'select',
    //   options: ctx.dictListMap?.settlementStatus,
    // },
    {
      name: '合同编号',
      prop: 'purchaseOrderNoStr',
      type: 'input',
      disabled: true,
      span: 7,
    },
    // {
    //   name: '结算单类型',
    //   prop: 'settlementType',
    //   type: 'select',
    //   disabled: true,
    //   options: ctx.dictListMap?.settlementType,
    // },
    {
      name: '付款申请单编号',
      prop: 'paymentApplyNumber',
      type: 'input',
      span: 7,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'paymentApplyNumber',
    title: '付款申请单编号',
    visible: true,
  },
  {
    field: 'purchaseOrderNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'payeeName',
    title: '供应商 ',
    visible: true,
  },
  {
    field: 'requestAmount',
    title: '申请金额原币',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'paidAmount',
    title: '已付款金额原币',
    visible: true,
  },
  // {
  //   field: 'deductionAmount',
  //   title: '可抵扣金额原币',
  //   visible: true,
  // },
  // {
  //   field: 'realityDeductionAmount',
  //   title: '本次抵扣金额原币',
  //   visible: true,
  //   editRender: { name: 'realityDeductionAmount' },
  // },
];
export const tableList = [
  {
    id: 1,
    paymentApplyNumber: 1111,
    settlementDesc: '说明',
    payeeName: 'A',
    requestAmount: '9000',
    paidAmount: 5000,
    deductionAmount: 4000,
    currencyName: 'TEST',
    purchaseOrderNo: 66666,
    realityDeductionAmount: '1',
  },
  {
    id: 2,
    paymentApplyNumber: 2222,
    settlementDesc: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 9000,
    deductionAmount: 8000,
    currencyName: 'TEST',
    purchaseOrderNo: 88888,
    realityDeductionAmount: '',
  },
  {
    id: 3,
    paymentApplyNumber: 3333,
    settlementDesc: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 8000,
    deductionAmount: 8000,
    currencyName: 'TEST',
    purchaseOrderNo: 88888,
    realityDeductionAmount: '',
  },
  {
    id: 4,
    paymentApplyNumber: 4444,
    settlementDesc: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 9000,
    deductionAmount: 9000,
    currencyName: 'TEST',
    purchaseOrderNo: 88888,
    realityDeductionAmount: '',
  },
  {
    id: 5,
    paymentApplyNumber: 5555,
    settlementDesc: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 7000,
    deductionAmount: 7000,
    currencyName: 'TEST',
    purchaseOrderNo: 88888,
    realityDeductionAmount: '',
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];
